import { doGet, doGet2 } from './common'
import { getCompletedBreaks } from 'services/user'
import sessionStorageWrapper from 'util/SessionStorageWrapper'
import localStorageWrapper from 'util/LocalStorageWrapper'

export const getBreakStatus = breakId => {
  return doGet(`/break/${breakId}/status`)
  // if (localStorageWrapper.getItem(`break-${breakId}`)) {
  //     return JSON.parse(localStorageWrapper.getItem(`break-${breakId}`));
  // } else {
  //     return {}
  // }
}

/*
    returns a promise with payload
    {
        success: Boolean
        detail: Object
    }

*/
export const getFeaturedBreaks = ({ limit, sponsoredOnly = false }) => {
  return doGet(`/break/featured?limit=${limit}&sponsoredOnly=${sponsoredOnly}`)
}

export const getPersonalityData = async breakId => {
  let returnedValue = null
  try {
    const storedId = sessionStorageWrapper.getItem(`${breakId}_pq_result_id`)
    if (storedId !== null) {
      returnedValue = storedId
    } else {
      let result = await doGet(`/break/${breakId}/personalityData`)

      returnedValue = result.detail.resultId
    }
  } catch (e) {
    console.log(e)
  }
  return returnedValue
}
export const getPointsForBreak = breakId => {
  return doGet(`/break/${breakId}/totalPoints`)
}

export const scrollToTopOfCurrentStep = stepId => {
  let obj = document.querySelector(`.step-topper-${stepId}`)
  if (obj) {
    obj && obj.scrollIntoView({ behavior: 'smooth', block: 'start' })
    obj &&
      window.parent.postMessage(
        { type: 'SCROLL_TO', value: obj.getBoundingClientRect().top },
        '*',
      )
  } else {
    console.log('no element found')
  }
}

export const scrollToTopOfEditorialStep = (behavior = 'smooth') => {
  let obj = document.querySelector(`main.editorial.container`)
  if (obj) {
    window.scrollTo({
      top: obj.offsetTop - 98, //approx. header height.
      behavior: behavior,
    })
  }
}

export const scrollToTopOfLandingStep = () => {
  let obj = document.querySelector('.sponsored-flow-wrapper')
  obj && obj.scrollIntoView({ behavior: 'smooth', block: 'start' })
  obj &&
    window.parent.postMessage(
      { type: 'SCROLL_TO', value: obj.getBoundingClientRect().top },
      '*',
    )
}

export const retrieveCompletedBreaksFromLocalOrAPI = breaks => {
  const retrieveCompletedBreaksFromLocal = breaks => {
    if (!window) return false
    const localObj = JSON.parse(
      localStorageWrapper.getItem('db_completed_brks'),
    )
    const localCompletedBrks = {}
    const leftoverBreaks = []
    if (localObj) {
      breaks.forEach(brk => {
        if (localObj[brk.id]) {
          localCompletedBrks[brk.id] = true
        } else {
          leftoverBreaks.push(brk)
        }
      })
      if (leftoverBreaks.length) {
        return retrieveCompletedBreaksFromAPI(
          localCompletedBrks,
          leftoverBreaks,
        )
      } else {
        // updateCompletedBreaks(localCompletedBrks)
        return localCompletedBrks
      }
    } else {
      return retrieveCompletedBreaksFromAPI(localCompletedBrks, breaks)
    }
  }

  const retrieveCompletedBreaksFromAPI = async (localCompletedBrks, breaks) => {
    let totalCompletedBrks = localCompletedBrks
    const breakIds = { breakIds: [...breaks].map(brk => brk.id) }
    try {
      const completedBrks = await getCompletedBreaks(breakIds)
      Object.keys(completedBrks.detail).forEach(key => {
        if (completedBrks.detail[key] === true) {
          totalCompletedBrks[key] = true
        }
      })
      // console.log('new api brks: ',completedBrks.detail)
      // console.log('total completed brks: ',totalCompletedBrks)
      // updateCompletedBreaks(totalCompletedBrks)
      saveCompletedBreaksToLocal(totalCompletedBrks)
      return totalCompletedBrks
    } catch (e) {
      console.log(e)
    }
  }

  const saveCompletedBreaksToLocal = breaks => {
    if (!window) return false
    const localObj = JSON.parse(
      localStorageWrapper.getItem('db_completed_brks'),
    )
    if (localObj) {
      Object.keys(breaks).forEach(id => {
        localObj[id] = true
      })
      localStorageWrapper.setItem('db_completed_brks', JSON.stringify(localObj))
    } else {
      localStorageWrapper.setItem('db_completed_brks', JSON.stringify(breaks))
    }
  }

  return retrieveCompletedBreaksFromLocal(breaks)
}

export const checkBreakTargetingForUser = breakId => {
  return doGet(`/break/${breakId}/isTargeted`)
}

export const getContentCenterBreaks = async (params = '') => {
  const response = await doGet2(`/content-center${params}`, {})
  const data = await response.json()
  return data
}

// Fetch a single break's raw JSON by slug/permalink at runtime.
// Same shape the /break and /embed pages get as pageContext.brk, so it can be
// fed straight into <BreakExperience> / useBreakData.
export const getBreakBySlug = async (slug, lang = 'en-US') => {
  const response = await doGet2(
    `/legacy/break/${encodeURIComponent(slug)}?lang=${encodeURIComponent(lang)}`,
    {},
  )
  if (!response.ok) {
    throw new Error(`getBreakBySlug ${slug} (${lang}) → HTTP ${response.status}`)
  }
  return response.json()
}
